import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import UploadImage from "common/uploadImage";
import { SHOW_VEHICLE, UPDATE_VEHICLE, DRIVERS_SEARCH, VEHICLE_ASSIGN_DRIVER, VEHICLE_CHECK_ALLOCATED, VEHICLE_CATEGORY_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";

//meta title
document.title = "Edit Vehicle";

const EditVehicle = ({vehicleId = null, onSuccess}) => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [driverId, setDriverId] = useState(null);
    const [drivers, setDrivers] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [vehicleCategoryId, setVehicleCategoryId] = useState('');
    const [vehicleCategories, setVehicleCategories] = useState([]);
    const [modelName, setModelName] = useState('');
    const [manufactureYear, setManufactureYear] = useState('');
    const [color, setColor] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [engineNo, setEngineNo] = useState('');
    const [conditioned, setConditioned] = useState(true);
    const [secured, setSecured] = useState(true);
    const [pilotNo, setPilotNo] = useState('');
    const [passangerNo, setPassangerNo] = useState('');
    const [trunkSize, setTrunkSize] = useState('');
    const [height, setHeight] = useState('');
    const [model, setModel] = useState('');
    const [plateNo, setPlateNo] = useState('');
    const [registrationSource, setRegistrationSource] = useState('');
    const [trailingUnits, setTrailingUnits] = useState('');
    const [registrationExpiry, setRegistrationExpiry] = useState('');
    const [capacity, setCapacity] = useState('');
    const [symbol, setSymbol] = useState('');
    const [status, setStatus] = useState(1);
    const [collectionHubVehicle, setCollectionHubVehicle] = useState(1);
    const [ownership, setOwnership] = useState('cargoo');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        getDrivers();
        setVehicleData();
    }, []);

    const getDrivers = () => {
        post(`${DRIVERS_SEARCH}`)
            .then(response => {
                setDrivers([{value: '0', label: 'None'}].concat(response.data.map(el => {
                    return {value: el.id, label: el.name}
                })));
            })
    };

    useEffect(() => {
        post(`${VEHICLE_CATEGORY_SEARCH}`)
            .then(response => {
                const categoryOptions = response.data.map(category => ({
                    value: category.id,
                    label: category.name
                }));
                setVehicleCategories(categoryOptions);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);


    const setVehicleData = () => {
        console.log('vehicleId', vehicleId, params.id);
        if(vehicleId === 0)
        {
            setLoading(false);
            return;
        }
        get(`${SHOW_VEHICLE}/${!vehicleId?params.id:vehicleId}`)
            .then(response => {
                const vehicle = response.data;
                console.log("vehicle.capacity", vehicle.capacity)
                setId(vehicle.id);
                setName(vehicle.name);
                setModelName(vehicle.modelName);
                setCategoryName(vehicle.categoryName);
                setStatus(vehicle.status);
                setCollectionHubVehicle(vehicle.collectionHubVehicle);
                setSymbol(vehicle.symbol);
                setManufactureYear(vehicle.manufactureYear);
                setColor(vehicle.color);
                setChasisNo(vehicle.chasisNo);
                setEngineNo(vehicle.engineNo);
                setConditioned(vehicle.conditioned);
                setVehicleCategoryId(vehicle.vehicleCategoryId);
                setSecured(vehicle.secured);
                setPilotNo(vehicle.pilotNo);
                setPassangerNo(vehicle.passangerNo);
                setTrunkSize(vehicle.trunkSize);
                setHeight(vehicle.height);
                setModel(vehicle.model);
                setPlateNo(vehicle.plateNo);
                setOwnership(vehicle.ownership);
                setRegistrationSource(vehicle.registrationSource);
                setRegistrationExpiry(vehicle.registrationExpiry ? vehicle.registrationExpiry.split('T')[0] : '');
                setCapacity(vehicle.capacity);
                setTrailingUnits(vehicle.trailingUnits);
                
                // Set driver if exists
                if (vehicle.driverId) {
                    setDriverId(vehicle.driverId);
                }
                
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching vehicle data:', error);
                setLoading(false);
                if (error.response?.status === 404) {
                    navigate('/vehicles');
                }
            })
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        let imagePath = symbol;
        if(document.getElementById('imagePath')) {
            imagePath = document.getElementById('imagePath').value || symbol;
        }
        
        const config = {
            id,
            name,
            categoryName,
            modelName,
            manufactureYear: Number(manufactureYear),
            color,
            chasisNo,
            engineNo,
            conditioned: Boolean(conditioned),
            secured: Boolean(secured),
            status: Number(status),
            collectionHubVehicle: Number(collectionHubVehicle),
            pilotNo: Number(pilotNo),
            passangerNo: Number(passangerNo),
            trunkSize,
            height,
            model,
            vehicleCategoryId,
            plateNo,
            registrationExpiry,
            registrationSource,
            capacity: Number(capacity),
            symbol: imagePath,
            trailingUnits: Number(trailingUnits),
            ownership,
            driverId: ownership === 'driver' ? driverId : null
        };
        
        put(UPDATE_VEHICLE, config)
            .then(response => {
                if (response.code === 200) {
                    setSuccessMsg("Vehicle Updated Successfully");
                    setTimeout(() => {
                        if(!vehicleId)
                            navigate('/vehicles', { state: { successMsg: 'Vehicle Updated SuccessFully' } });
                        else
                            onSuccess();
                    }, 1500);
                }
            })
            .catch(error => {
                setErrorMsg(error.response?.data?.message || 'Vehicle Update Failed');
            })
    }

    const renderMessages = () => (
        <Row>
            <Col md={12}>
                {errorMsg && (
                    <Alert color="danger" className="mt-3">
                        {errorMsg}
                    </Alert>
                )}
                {successMsg && (
                    <Alert color="success" className="mt-3">
                        {successMsg}
                    </Alert>
                )}
            </Col>
        </Row>
    );

    if (loading) {
        return <Loader />;
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Vehicles" breadcrumbItem="Edit Vehicle" />
                    
                    {renderMessages()}
                    
                    <Form
                        className="form-horizontal"
                        onSubmit={handleSubmit}
                    >
                        <Row>
                            <Col xl={6}>
                                <Card>
                                    <CardBody>
                                        <h4 className="card-title"><Trans>General Information</Trans></h4>
                                        <Row>
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Name</Trans></Label>
                                                <Input
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    required 
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Vehicle Category</Trans></Label>
                                                <Select
                                                name="vehicleCategoryId"
                                                value={vehicleCategories.filter(option => {return vehicleCategoryId==option.value})}
                                                options={vehicleCategories} 
                                                className="form-control select2"
                                                onChange={(e) => setVehicleCategoryId(e.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Model Name</Trans></Label>
                                                <Input
                                                    name="modelName"
                                                    className="form-control"
                                                    placeholder="Enter Model Name"
                                                    type="text"
                                                    value={modelName}
                                                    onChange={(e) => setModelName(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Category Name</Trans></Label>
                                                <Input
                                                    name="categoryName"
                                                    className="form-control"
                                                    placeholder="Enter Category Name"
                                                    type="text"
                                                    value={categoryName}
                                                    onChange={(e) => setCategoryName(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Ownership</Trans></Label>
                                                <Input
                                                    type="select"
                                                    className="form-control"
                                                    value={ownership}
                                                    onChange={(e) => setOwnership(e.target.value)}
                                                >
                                                    <option value="cargoo">Cargoo</option>
                                                    <option value="driver">Driver</option>
                                                </Input>
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Height</Trans></Label>
                                                <Input
                                                    name="height"
                                                    className="form-control"
                                                    placeholder="Enter Height"
                                                    type="text"
                                                    value={height}
                                                    onChange={(e) => setHeight(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Model</Trans></Label>
                                                <Input
                                                    name="model"
                                                    className="form-control"
                                                    placeholder="Enter Model"
                                                    type="text"
                                                    value={model}
                                                    onChange={(e) => setModel(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Capacity</Trans></Label>
                                                <Input
                                                    name="capacity"
                                                    className="form-control"
                                                    placeholder="Enter Capacity"
                                                    type="number"
                                                    value={capacity}
                                                    onChange={(e) => setCapacity(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Manufacture Year</Trans></Label>
                                                <Input
                                                    name="manufactureYear"
                                                    className="form-control"
                                                    placeholder="Enter Manufacture Year"
                                                    type="text"
                                                    value={manufactureYear}
                                                    onChange={(e) => setManufactureYear(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="defaultCheck2"
                                                        checked={status === 1}
                                                        onChange={()=> setStatus(prev => prev === 1 ? 0 : 1)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="defaultCheck2"
                                                    >
                                                        <Trans>Active</Trans>
                                                    </label>
                                                </div>
                                            </div>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col xl={6}>
                                <Card>
                                    <CardBody>
                                        <h4 className="card-title"><Trans>Vehicle Information</Trans></h4>
                                        <Row>
                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Chasis Number</Trans></Label>
                                                <Input
                                                    name="chasisNo"
                                                    className="form-control"
                                                    placeholder="Enter Chasis Number"
                                                    type="text"
                                                    value={chasisNo}
                                                    onChange={(e) => setChasisNo(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 mt-2">
                                                <Label className="form-label"><Trans>Engine Number</Trans></Label>
                                                <Input
                                                    name="engineNo"
                                                    className="form-control"
                                                    placeholder="Enter Engine Number"
                                                    type="text"
                                                    value={engineNo}
                                                    onChange={(e) => setEngineNo(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Color</Trans></Label>
                                                <Input
                                                    name="color"
                                                    className="form-control"
                                                    placeholder="Enter Color"
                                                    type="text"
                                                    value={color}
                                                    onChange={(e) => setColor(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Pilot Number</Trans></Label>
                                                <Input
                                                    name="pilotNo"
                                                    className="form-control"
                                                    placeholder="Enter Pilot Number"
                                                    type="number"
                                                    value={pilotNo}
                                                    onChange={(e) => setPilotNo(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Passenger Number</Trans></Label>
                                                <Input
                                                    name="passangerNo"
                                                    className="form-control"
                                                    placeholder="Enter Passenger Number"
                                                    type="number"
                                                    value={passangerNo}
                                                    onChange={(e) => setPassangerNo(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Trunk Size</Trans></Label>
                                                <Input
                                                    name="trunkSize"
                                                    className="form-control"
                                                    placeholder="Enter Trunk Size"
                                                    type="text"
                                                    value={trunkSize}
                                                    onChange={(e) => setTrunkSize(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Plate Number</Trans></Label>
                                                <Input
                                                    name="plateNo"
                                                    className="form-control"
                                                    placeholder="Enter Plate Number"
                                                    type="text"
                                                    value={plateNo}
                                                    onChange={(e) => setPlateNo(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Registration Source</Trans></Label>
                                                <Input
                                                    name="registrationSource"
                                                    className="form-control"
                                                    placeholder="Enter Registration Source"
                                                    type="text"
                                                    value={registrationSource}
                                                    onChange={(e) => setRegistrationSource(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Registration Expiry</Trans></Label>
                                                <Input
                                                    name="registrationExpiry"
                                                    className="form-control"
                                                    placeholder="Enter Registration Expiry"
                                                    type="date"
                                                    value={registrationExpiry}
                                                    onChange={(e) => setRegistrationExpiry(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Trailing Units</Trans></Label>
                                                <Input
                                                    name="trailingUnits"
                                                    className="form-control"
                                                    placeholder="Enter Trailing Units"
                                                    type="number"
                                                    value={trailingUnits}
                                                    onChange={(e) => setTrailingUnits(e.target.value)}
                                                />
                                            </div>

                                            {ownership === 'driver' && (
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Driver</Trans></Label>
                                                    <Select
                                                        name="driverId"
                                                        value={drivers.filter(option => {
                                                            return driverId == option.value
                                                        })}
                                                        options={drivers}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        onChange={(e)=> setDriverId(e.value)}
                                                        placeholder="Select Driver"
                                                    />
                                                </div>
                                            )}

                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Collection Hub Driver</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="defaultCheck2"
                                                        checked={collectionHubVehicle === 1}
                                                        onChange={() => setCollectionHubVehicle(prev => prev === 1 ? 0 : 1)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="conditionedCheck"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Conditioned</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="defaultCheck2"
                                                        checked={conditioned}
                                                        onChange={() => setConditioned(prev => !prev)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="conditionedCheck"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Secured</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="defaultCheck2"
                                                        checked={secured}
                                                        onChange={() => setSecured(prev => !prev)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="securedCheck"
                                                    />
                                                </div>
                                            </div>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col xl={6}>
                                <Card>
                                    <CardBody>
                                        <h4 className="card-title"><Trans>Media Section</Trans></h4>
                                        <Row>
                                            <UploadImage 
                                                state={{ 
                                                    InputLabel: 'Image', 
                                                    filePath: symbol, 
                                                    type: 'vehicles', 
                                                    InputWidth: '12' 
                                                }} 
                                            />
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            
                            <div className="mt-4">
                                <Button type="submit" color="danger">
                                    <Trans>Update</Trans>
                                </Button>
                            </div>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditVehicle